uniform float uTime;
uniform float uSize;
uniform float uPixelRatio;

attribute float aScale;
attribute float aOffset; // 個体ごとの位相（0-1）

varying float vOffset;

void main()
{
    vec3 pos = position;

    // 天体のまわりをゆっくり漂う揺らぎ
    float phase = aOffset * 6.2831;
    pos.x += sin(uTime * 0.35 + phase) * 0.35;
    pos.y += sin(uTime * 0.28 + phase * 2.0) * 0.30;
    pos.z += cos(uTime * 0.32 + phase) * 0.35;

    vec4 viewPosition = viewMatrix * modelMatrix * vec4(pos, 1.0);
    gl_Position = projectionMatrix * viewPosition;

    // 遠近でサイズを変える
    gl_PointSize = uSize * aScale * uPixelRatio * (1.0 / -viewPosition.z);

    vOffset = aOffset;
}
